import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const SUBMIT_COOLDOWN = 300000; // 60 seconds in milliseconds

function NominationModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    category: 'flower',
    photo: null
  });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    const lastSubmitTime = localStorage.getItem('lastNominationSubmit');
    if (lastSubmitTime) {
      const timePassed = Date.now() - parseInt(lastSubmitTime);
      const remaining = Math.max(0, SUBMIT_COOLDOWN - timePassed);
      setTimeRemaining(remaining);

      if (remaining > 0) {
        const timer = setInterval(() => {
          setTimeRemaining(prev => {
            const newTime = Math.max(0, prev - 1000);
            if (newTime === 0) clearInterval(timer);
            return newTime;
          });
        }, 1000);
        return () => clearInterval(timer);
      }
    }
  }, [isOpen]);

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, photo: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (timeRemaining > 0) {
      alert(`請等待一陣之後再次提交`);
      return;
    }

    if (!formData.photo || !formData.name) {
      alert('請填寫姓名並上傳照片');
      return;
    }

    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('category', formData.category);
    formDataToSend.append('photo', formData.photo);

    try {
      await axios.post(`${API_URL}/api/nominate`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      localStorage.setItem('lastNominationSubmit', Date.now().toString());
      setTimeRemaining(SUBMIT_COOLDOWN);
      
      alert('提名成功！刷新網頁後就可以見到');
      onClose();
      setFormData({ name: '', category: 'flower', photo: null });
      setPreview(null);
    } catch (error) {
      alert('失敗，請稍後再試');
      console.error('Error submitting nomination:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <h3 className="text-2xl font-bold mb-4 text-pink-500">提名校花/校草</h3>
        <form onSubmit={handleSubmit}>
          {timeRemaining > 0 && (
            <div className="mb-4 text-red-500">
              請等待一陣之後再次提交
            </div>
          )}
          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text text-gray-600">名稱</span>
            </label>
            <input
              type="text"
              className="input input-bordered focus:border-pink-500"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </div>

          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text text-gray-600">類別</span>
            </label>
            <div className="flex gap-4">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  className="radio radio-pink"
                  name="category"
                  checked={formData.category === 'flower'}
                  onChange={() => setFormData({ ...formData, category: 'flower' })}
                />
                <span className="text-gray-700">校花</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  className="radio radio-pink"
                  name="category"
                  checked={formData.category === 'grass'}
                  onChange={() => setFormData({ ...formData, category: 'grass' })}
                />
                <span className="text-gray-700">校草</span>
              </label>
            </div>
          </div>

          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text text-gray-600">照片</span>
            </label>
            <input
              type="file"
              className="file-input file-input-bordered focus:border-pink-500"
              accept="image/*"
              onChange={handlePhotoChange}
              required
            />
          </div>

          {preview && (
            <div className="mb-4">
              <img
                src={preview}
                alt="Preview"
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
          )}

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="btn btn-ghost text-pink-500"
              onClick={onClose}
              disabled={loading}
            >
              取消
            </button>
            <button
              type="submit"
              className="btn bg-pink-500 hover:bg-pink-600 text-white"
              disabled={loading}
            >
              {loading ? <span className="loading loading-spinner"></span> : '提交'}
            </button>
          </div>
          <div className="text-gray-500 text-sm mt-3 text-center">
            請勿發布不當內容
          </div>
        </form>
      </div>
    </div>
  );
}

export default NominationModal;
